import React from 'react';
import PropTypes from 'prop-types';
import BlazeModal from '@blaze-react/modal';
import { renderChildren, updateChildrensParent, hasChildren } from '../../helpers';

const Modal = ({ children, elementTitle, onClose, ...otherProps }) => {
  if (!hasChildren(children)) return null;

  updateChildrensParent(children, otherProps.parent.itemId, otherProps.parent.itemEntity);
  return (
    <BlazeModal title={elementTitle} onClose={onClose}>
      {renderChildren(children)}
    </BlazeModal>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func,
  elementTitle: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

Modal.defaultProps = {
  onClose: () => {},
  elementTitle: '',
  children: []
};

export default Modal;
